@if (apiloaded) {
  <div class="row col-12 col-sm-12 manage-user-container my-account-container">
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'MyDocumentNavNode'"
      [childNavState]="'MyFavoriteNavNode'"></app-my-account-left-sidenav>
    </div>
    <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
      <h1 class="myProfileTopHeader m-0">{{'common.text_account_document_favorite_heading_NA'|cxTranslate}}
      </h1>
      <div class="myProfileBody">
        <p class="textColor mb-0">
          {{userList?.pagination?.totalResults ??0}}
          {{'common.text_account_document_favorite_totalResults'|cxTranslate}}
        </p>
      </div>
      <!-- here the content goes for table to display the tickets -->
      @if ( userList?.documents && userList?.documents.length>0) {
        <div>
          <div class="favourite-shopping-cart-table mycompany-manageUser">
            <table class="responsive-table table table-bordered table-blue savedShoppingCartTable">
              <thead>
                <tr class="responsive-table-head hidden-xs hidden-sm">
                  <th scope="col">
                    <a class="a-underline fav-text" (click)="sort('byDocumentNumber')">
                      <span>{{'common.text_account_document_favorite_table_doc_number'|cxTranslate}}
                      </span>
                    </a>
                    @if (sortByDocNo == 'asc') {
                      <span class="new-class">&#8593;</span>
                    }
                    @if (sortByDocNo == 'desc') {
                      <span
                      class="new-class">&#8595;</span>
                    }
                  </th>
                  <th scope="col">
                    <a class="a-underline fav-text" (click)="sort('byDocumentDescription')">
                      <span>{{'common.text_account_document_favorite_table_doc_description'|cxTranslate}}
                      </span>
                    </a>
                    @if (sortByDesc == 'asc') {
                      <span class="new-class">&#8593;</span>
                    }
                    @if (sortByDesc == 'desc') {
                      <span
                      class="new-class">&#8595;</span>
                    }
                  </th>
                  <th scope="col">
                    <a class="a-underline fav-text" (click)="sort('byDocumentType')">
                      <span>{{'common.text_account_document_favorite_table_doc_type'|cxTranslate}}
                      </span>
                    </a>
                    @if (sortByDocType == 'asc') {
                      <span class="new-class">&#8593;</span>
                    }
                    @if (sortByDocType == 'desc') {
                      <span
                      class="new-class">&#8595;</span>
                    }
                  </th>
                  <th scope="col">
                    <a>
                      <span
                        class="fav-text">{{'common.text_account_document_favorite_table_doc_language'|cxTranslate}}
                      </span>
                    </a>
                  </th>
                  <th scope="col">
                    <a>
                      <span
                        class="fav-text">{{'common.text_account_document_favorite_table_doc_rev'|cxTranslate}}
                      </span>
                    </a>
                  </th>
                  <th scope="col">
                    <a>
                      <span class="fav-text">{{'common.cart_groups_remove'|cxTranslate}}
                      </span>
                    </a>
                  </th>
                </tr>
              </thead>
              @if (userList) {
                <tbody>
                  @for (item of userList?.documents; track item) {
                    <tr class="responsive-table-item">
                      <td class="responsive-table-cell">
                        <span
                        class="d-lg-none favourite-cart-label">{{'common.text_account_document_favorite_table_doc_number'|cxTranslate}}</span>
                        <a (click)="getPdfWithTimestamp(item)">
                          <span class="doc-code">
                            {{item?.favoriteListEntryDocument?.code}}
                          </span></a>
                        </td>
                        <td class="responsive-table-cell">
                          <span
                          class="d-lg-none favourite-cart-label">{{'common.text_account_document_favorite_table_doc_description'|cxTranslate}}</span>
                          <a><span
                          class="mycompnay-registration-value pointer">{{item.favoriteDocumentDescription}}</span></a>
                        </td>
                        <td class="responsive-table-cell">
                          <span
                          class="d-lg-none favourite-cart-label">{{'common.text_account_document_favorite_table_doc_type'|cxTranslate}}</span>
                          <a>
                            <span class="mycompnay-registration-value pointer">
                              {{item?.favoriteListEntryDocument?.docType}}
                            </span></a>
                          </td>
                          <td class="responsive-table-cell">
                            <span
                            class="d-lg-none favourite-cart-label">{{'common.text_account_document_favorite_table_doc_language'|cxTranslate}}</span>
                            <a><span
                            class="mycompnay-registration-value pointer">{{item?.favoriteDocumentLanguage}}</span></a>
                          </td>
                          <td class="responsive-table-cell">
                            <span
                            class="d-lg-none favourite-cart-label">{{'common.text_account_document_favorite_table_doc_rev'|cxTranslate}}</span>
                            <span class="mycompnay-registration-value">
                              <span>{{item?.favoriteListEntryDocument?.revision}}</span>
                            </span>
                          </td>
                          <td class="responsive-table-cell email action-col restore-button">
                            <span
                              class="d-none d-sm-none d-md-none favourite-cart-label">{{'common.cart_groups_remove'|cxTranslate}}
                            </span>
                            <span class="d-none d-lg-block">
                              <img style="cursor: pointer;" src="/icons/close-red.svg"
                                (click)="unSubscribeDoc(item)" width="20px" style="cursor: pointer;">
                              </span>
                            </td>
                            <td class="responsive-table-cell d-lg-none action-col favourite-remove-button">
                              <img src="/icons/close-red.svg" (click)="unSubscribeDoc(item)" width="20px"
                                style="cursor: pointer;" alt="unSubscribeDoc">
                              </td>
                            </tr>
                          }
                        </tbody>
                      }
                    </table>
                  </div>
                  <div class="account-orderhistory-pagination company-users-pagination">
                    <div class="product__list--wrapper py-2">
                      <div class="pagination-bar favourite-cart-pagination">
                        <div class="pagination-toolbar">
                          <div class="row sort-refine-bar">
                            <div class="col-xs-12 col-sm-12 col-md-6 bottom-result">
                              <div class="pagination-result">
                                {{'common.search_page_showing_text'|cxTranslate}}
                                {{(userList.pagination.pageSize *
                                userList.pagination.currentPage)+1 }} -
                                @if (userList.pagination.pageSize > userList.pagination.totalResults) {
                                  <span
                                    >
                                  {{userList.pagination.totalResults}} </span>
                                }
                                @if ((userList.pagination.pageSize *(userList.pagination.currentPage+1) < userList.pagination.totalResults)&&(userList.pagination.pageSize < userList.pagination.totalResults)) {
                                  <span
                                    >
                                    {{userList.pagination.pageSize*(userList.pagination.currentPage+1)}}
                                    {{'common.search_page_of_text'|cxTranslate}}
                                  {{userList.pagination.totalResults}} </span>
                                }
                                @if ((userList.pagination.pageSize *(userList.pagination.currentPage+1) > userList.pagination.totalResults)&&(userList.pagination.pageSize < userList.pagination.totalResults)) {
                                  <span
                                    >{{userList.pagination.totalResults}}
                                  of {{userList.pagination.totalResults}} </span>
                                }
                                {{'common.search_page_result_text'|cxTranslate}}
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination">
                              <kb-pagination [pagination]="$any(userList)?.pagination" [defaultPage]="0"
                              (viewPageEvent)="changePageCustom($event, $any(userList)?.searchPageData)"></kb-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }